// Classify by the API's title metadata, never by a guessed opcode name.
const oilOpcodes = new Set();
const codeOf = item => String(item?.opCode ?? item?.opcode ?? '').trim().toUpperCase();
const children = ['parts_op_code_breakdown', 'parts_detail', 'service_details', 'motor_details'];
export function hasEngineOilTitle(item, seen = new Set()) {
  if (!item || typeof item !== 'object' || seen.has(item)) return false;
  seen.add(item);
  if (Array.isArray(item)) return item.some(value => hasEngineOilTitle(value, seen));
  if (String(item.title || '').trim().toLowerCase() === 'engine oil') return true;
  return children.some(key => hasEngineOilTitle(item[key], seen));
}
export function registerEngineOilMetadata(value, seen = new Set()) {
  if (!value || typeof value !== 'object' || seen.has(value)) return;
  seen.add(value);
  if (!Array.isArray(value) && codeOf(value) && hasEngineOilTitle(value)) oilOpcodes.add(codeOf(value));
  Object.values(value).forEach(child => registerEngineOilMetadata(child, seen));
}
export function clearEngineOilMetadata() { oilOpcodes.clear(); }
export function isEngineOil(item) {
  return hasEngineOilTitle(item) || Boolean(codeOf(item) && oilOpcodes.has(codeOf(item)));
}
// Preserve the first selected oil service, including an existing package line.
export function oneEngineOil(items) {
  let found = false;
  return (Array.isArray(items) ? items : []).filter(item => {
    if (!isEngineOil(item)) return true;
    if (found) return false;
    found = true;
    return true;
  });
}
export function canAddEngineOil(item, cart) {
  return !isEngineOil(item) || !(cart || []).some(isEngineOil);
}
export function appointmentCartKey(data) {
  const id = data?.apptId ?? data?.appointmentId ?? data?.appointment_id;
  if (id == null || String(id).trim() === '') return '';
  return String(data?.store_id ?? '') + ':' + String(id);
}
